import {find, findIn, findAll} from '@elements/dom-utils';
import {onFind, findAllIn} from "@elements/init-modules-in-scope";

const defaultSelectors = {
    base: '.js-service-teaser-remove',
    info: '.js-service-teaser-info',
    teaser: '.js-service-teaser',
};

export function init(selectors = defaultSelectors) {

    let info = find(selectors.info);

    onFind(selectors.base, function (baseElement) {
        baseElement.addEventListener("click", function (event) {
            let teasers = findAll(selectors.teaser);

            teasers.forEach((teaser) => {
                if (teaser.id === event.currentTarget.id) {
                    teaser.classList.add('removed');
                    teaser.addEventListener("transitionend" , (e) => setTimeout(() => teaser.remove(), e.elapsedTime + 100));
                }
            })

            if (teasers.length <= 1) {
                info.classList.remove('d-none');
            }
        })
    })
}